import { Component, Input } from '@angular/core';

@Component({
    selector: 'projected-balance-alertbox',
    templateUrl: './projected-balance-alertbox.component.html',
    styleUrls: ['./projected-balance-alertbox.component.scss']
})
export class ProjectedBalanceAlertboxComponent {
    @Input() public debitValue: number;

    public constructor(
    ) {}

}
